import 'src/assets/css/index.css';
import 'src/i18n';
import 'typeface-montserrat';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { NuqsAdapter } from 'nuqs/adapters/react';
import React, { StrictMode } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import { GlobalLoadingIndicator } from 'src/components/loadingIndicators/LoadingGlobalIndicator';
import { AuthProvider } from 'src/components/providers/AuthProvider';
import { ThemeProvider } from 'src/providers/ThemeProvider';
import { reportWebVitals } from 'src/reportWebVitals';
import { router } from 'src/routes/router';
import { trace } from 'src/tracing';

trace();

const root: Root = createRoot(
  document.querySelector('[role=application]') as Element,
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

root.render(
  <StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <ThemeProvider>
          <NuqsAdapter>
            <QueryClientProvider client={queryClient}>
              <GlobalLoadingIndicator />
              <RouterProvider router={router} />
            </QueryClientProvider>
          </NuqsAdapter>
        </ThemeProvider>
      </AuthProvider>
    </HelmetProvider>
  </StrictMode>,
);

reportWebVitals(console.info);
